import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import * as _ from 'lodash';
import {
  cents
} from '../../../filters/number';

const CLASS_PIN_REGULAR = "pin";
const CLASS_PIN_SELECTED = "pin-selected";


//// funções para criar um pin customizado
//// todo: refatorar para permitir reutilização

const counterPinCache = new Map();
// Necessário especificar o prefixo "!!raw-loader!" para o webpack forçar carregar
// o arquivo como string.
const counterPinTemplate = require('!!raw-loader!../../../assets/markers/pin.svg');

function createCounterPin(val, clazz) {
  let key = JSON.stringify(arguments);

  // verifica cache
  let pin = counterPinCache.get(key);
  if (pin) return pin;

  let pinSvg = $(counterPinTemplate);
  pinSvg.find('#icon').addClass(clazz);

  pinSvg.find('#value')
    .addClass(clazz)
    .text(val);

  let _html = $('<div>').append($(pinSvg).clone()).html();
  pin = "data:image/svg+xml;base64," + btoa(_html);
  counterPinCache.set(key, pin);
  return pin;
}
////

function markerFromPlace(p) {
  //let y = Math.sqrt(p.quantity) * 40;
  let size = 50; //Math.max(Math.min(y, 70), 40);
  let marker = L.marker([p.pointLat, p.pointLng], {
    icon: L.icon({
      iconUrl: createCounterPin(p.qtd, CLASS_PIN_REGULAR),
      iconSize: [size, size],
      //iconAnchor: [size * 0.5, size],
      //popupAnchor: [size * 0,5, 100]
    })
  });

  // Adiciona propriedade passageCount
  marker.passageCount = p.qtd;

  return marker;
}

export default {
  props: ['summary', 'selection'],

  data() {
    return {
      markers: [],
      map: undefined,
      group: L.featureGroup()
    };
  },

  watch: {
    summary(val) {
      this.group.clearLayers();

    //Quando nenhum registro for encontrado apenas limpa o mapa.
      if (!val)
        return false;

      _.each(val, obj => {
        if (obj.pointLat && obj.pointLng) {
          let marker = markerFromPlace(obj);
          marker.bindPopup(`<b>${obj.description}</b><br>Quantidade de passagens: ${obj.qtd}<br>Total das passagens: ${cents(obj.total)}`);
          this.markers[obj.maplinkId] = marker;
          this.group.addLayer(marker);
          //marker.addTo(this.map);
        }
      });
      this.map.addLayer(this.group);
      this.map.fitBounds(this.group.getBounds(), {
        padding: [50, 50]
      });
    },

    selection(newId, oldId) {
      if (newId == oldId) return;

      let changeIcon = (id, color) => {
        let marker = this.markers[id];
        if (marker) {
          let options = _.clone(marker.options.icon.options);
          options.iconUrl = createCounterPin(marker.passageCount, color);
          marker.setIcon(L.icon(options));
        }
      };

      if (newId !== undefined) changeIcon(newId, CLASS_PIN_SELECTED);
      if (oldId !== undefined) changeIcon(oldId, CLASS_PIN_REGULAR);

    }
  },

  mounted() {
    this.map = L.map(this.$el).setView([-23.533773, -46.625290], 13);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy;<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/vehicle/vehicle-map.js